module.exports = __webpack_public_path__ + "media/images/landing__bg-f6879c75a0d24bb1c78b78db60b6e84c.jpg";